import React from "react";
import { useTranslation } from "@helpers/translate";
import { LEVERAGE_MIN, LEVERAGE_MAX } from "../../constants";
import { useLeverageSlider } from "../../hooks/useLeverageSlider";
import "./LeverageSlider.sass";

/**
 * Presentational leverage slider (value + onChange).
 *
 * @param {object} props
 * @param {number} props.value
 * @param {(value: number) => void} props.onChange
 */
export const LeverageSlider = ({ value, onChange }) => {
  const { __ } = useTranslation();
  const {
    trackRef,
    isDragging,
    visualPosition,
    markCount,
    steps,
    handlePointerDown,
    handlePointerMove,
    handlePointerUp,
    handleKeyDown,
  } = useLeverageSlider({ value, onChange });

  return (
    <div
      className={`leverage-slider${isDragging ? " leverage-slider--dragging" : ""}`}
      ref={trackRef}
      role="slider"
      tabIndex={0}
      aria-valuemin={LEVERAGE_MIN}
      aria-valuemax={LEVERAGE_MAX}
      aria-valuenow={Number(value) || LEVERAGE_MIN}
      aria-label={__("futures.leverage")}
      onPointerDown={handlePointerDown}
      onPointerMove={handlePointerMove}
      onPointerUp={handlePointerUp}
      onPointerCancel={handlePointerUp}
      onKeyDown={handleKeyDown}
    >
      <div className="leverage-slider__track">
        {steps.map((step, index) => (
          <span
            key={step}
            className="leverage-slider__mark"
            style={{ left: `${(index / markCount) * 100}%` }}
            aria-hidden="true"
          />
        ))}

        <div
          className="leverage-slider__fill"
          style={{ width: `${visualPosition}%` }}
        />

        <div
          className="leverage-slider__thumb"
          style={{ left: `${visualPosition}%` }}
        />
      </div>
    </div>
  );
};

export default LeverageSlider;
